import styled from 'styled-components';
import { Button } from '@hqo/react-components-library/dist/atoms/button';

export const FilterSection = styled.div`
  margin-bottom: 24px;
`;

export const CollectionsFilterTitle = styled.h3`
  margin-bottom: 16px;
  font: normal 16px/19px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.greys.sharedDarkGrey};
`;

interface ChipsContainerProps {
  isExpanded: boolean;
}

export const ChipsContainer = styled.div<ChipsContainerProps>`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  max-height: ${({ isExpanded }) => (isExpanded ? 'none' : '82px')};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;

// Same look as the types filter's "View more" (see `pages/filter-modal/types-filter/styles.ts`) — the
// two are the same control on two different filters and should read as one pattern.
export const ViewMoreButton = styled(Button)`
  text-decoration: underline;
`;
